import firebase from 'firebase/app'
import 'firebase/firestore';

const config = {
    apiKey: "AIzaSyDb0S-DYoPZ6UiRfP-szb93I64IJHUSNLI",
    authDomain: "pustakatech.firebaseapp.com",
    projectId: "pustakatech",
    storageBucket: "pustakatech.appspot.com",
    messagingSenderId: "272465296856",
    appId: "1:272465296856:web:adadb2a2bf5d9e97ae86ad",
    measurementId: "G-PBBLJCELWV"
}

const firebaseApp = firebase.initializeApp(config)

const db = firebaseApp.firestore()
const projectCollection = db.collection('projects')
const pageCollection = db.collection('page')


export const projectById =  async id => {
    const user = await projectCollection.doc(id).get()
    return user.exists ? user.data() : null
}

export const projectList = () => {
    return projectCollection.get()
        .then((querySnapshot) => {
            return querySnapshot.docs.map(doc => ({id: doc.id, ...doc.data()}))
        }).catch((err) => {
        return err
    })
}

export const pageList = () => {
    return pageCollection.get()
        .then((querySnapshot) => {
            return querySnapshot.docs.map(doc => ({id: doc.id, ...doc.data()}))
        }).catch((err) => {
            return err
        })
}

export const pageById =  async id => {
    const page = await pageCollection.doc(id).get()
    return page.exists ? page.data() : null
}